import React, { useState, useEffect } from 'react';
import { getMenuCategories } from '../api/api';

const HERO_IMG = '/images/restaurant/12-steak-grille.jpg';
const BACKEND_URL = window.location.origin;

const MenuPage = () => {
  const [menuData, setMenuData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const data = await getMenuCategories();
        setMenuData(data);
      } catch (error) {
        console.error('Error:', error);
      } finally { setLoading(false); }
    };
    fetchMenu();
  }, []);

  return (
    <div className="bg-[#fafaf9]">
      {/* Hero */}
      <section className="relative w-full h-[50vh] flex items-center justify-center overflow-hidden" data-testid="menu-hero">
        <img src={HERO_IMG} alt="Menu" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/55" />
        <div className="relative z-10 text-center mt-12">
          <span className="text-stone-300 text-[10px] tracking-[0.4em] uppercase block mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>La Taverne</span>
          <h1 className="text-white text-5xl md:text-7xl font-light tracking-tighter" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Notre Carte
          </h1>
        </div>
      </section>

      {/* Menu Content */}
      <section className="max-w-5xl mx-auto py-16 px-4 md:px-8">
        {loading ? (
          <div className="text-center py-20 text-stone-400">Chargement du menu...</div>
        ) : (
          menuData.map((category, catIdx) => (
            <div key={category.id} className="mb-20" data-testid={`menu-category-${catIdx}`}>
              <h2 className="text-3xl md:text-4xl font-light text-center mb-12 pb-4 border-b border-stone-200 text-stone-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                {category.name}
              </h2>
              <div className="space-y-6">
                {category.items.map((item, idx) => (
                  <div key={item.id || idx} className="group flex flex-col md:flex-row gap-4 items-start md:items-center" data-testid={`menu-item-${catIdx}-${idx}`}>
                    {item.image && (
                      <img src={item.image} alt={item.name} className="w-full md:w-28 h-40 md:h-28 object-cover bg-stone-200 shrink-0" />
                    )}
                    <div className="flex-grow flex flex-col justify-center w-full">
                      <div className="flex justify-between items-baseline border-b border-stone-200/50 pb-1.5 mb-1">
                        <h3 className="text-xl text-stone-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{item.name}</h3>
                        <span className="text-lg text-red-900 font-medium shrink-0 ml-4" style={{ fontFamily: "'Outfit', sans-serif" }}>{item.price}&euro;</span>
                      </div>
                      {item.description && (
                        <p className="text-stone-500 text-sm leading-relaxed" style={{ fontFamily: "'Outfit', sans-serif" }}>{item.description}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </section>
    </div>
  );
};

export default MenuPage;
